<template>
  <v-container class="text-center pl-0 pr-0" fluid>

    <v-card v-if="countTreinos == 0 && $store.getters.userLogged.profile.professor != null">
      <v-card-text class="title">
        Opa! Você ainda não tem treinos agendados... <br/><br/>Peça para {{$store.getters.userLogged.profile.professor.fullName}} agendar treinos para você.
      </v-card-text>
    </v-card>

    <v-card class="" v-if="countTreinos > 0" dark>
      <v-card-text class="mb-5">
        <v-select
          :items="periodo"
          v-model="periodoSelecionado"
          label="Período (a partir de)"
          item-text="name"
          @change="selecionaPeriodo"
          return-object
        ></v-select>
      </v-card-text>
    </v-card>

    <!-- <CardTreino v-bind:item="item" v-for="item in treinoList" :key="item.id" class="mb-5"/>   -->
    <v-row class="pt-4">
      <v-col v-for="item in treinoList" :key="item.id" cols="12" md="6" lg="4" xl="3">
        <card-treino :item="item" />
      </v-col>
    </v-row>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Espera um pouquinho...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  
  </v-container>
  
</template>

<script>
//import { mdiEmoticonNeutralOutline } from '@mdi/js';

import axios from "axios";
import HOST from "../ws";
import CardTreino from '../components/CardTreino';

export default {
  //components: {
  //mdiEmoticonNeutralOutline,
  //},

  components : {
    CardTreino,
  },

  props: {
    source: String
  },
  data: () => ({

    myHost: HOST.HOST,

    treinoList : [],

    countTreinos : 1,

    dialogLoader : false,

    periodo : [
      {name : 'Hoje', dias : 1},
      {name : 'Últimos 7 dias', dias : 7},
      {name : 'Ultimos 15 dias', dias : 15},
      {name : 'Últimos 30 dias', dias : 30},
      {name : 'Últimos 6 meses', dias : 180},
      {name : 'Último ano', dias : 365},
      {name : 'Todos', dias : 0},
    ],

    periodoSelecionado : null,
  }),
  mounted (){

      this.periodoSelecionado = this.periodo[0];

      //carrega os treinos:
      this.dialogLoader = true;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/meustreinosativos", {}, config)
        .then(response => {
          this.treinoList = response.data;
          //console.log(this.treinoList);

          //carrega o numero de treinos marcados:
          axios
            .post(this.myHost + "/treino/numerodetreinosprogramados", {}, config)
            .then(response2 => {
              this.countTreinos = response2.data;
              console.log('total de treinos agendados: ' + this.countTreinos);
            })
            .catch(error2 => {
              console.log(error2.message);
              this.$store.commit("logout");
              this.$router.push("/");
            });

          this.dialogLoader = false;
        })
        .catch(error => {
          this.dialogLoader = false;
          console.log(error.message);
          this.$store.commit("logout");
          this.$router.push("/");
        });

    
    
  },
  methods : {

    selecionaPeriodo(){
      console.log('periodo selecionado: \n' + JSON.stringify(this.periodoSelecionado));
      this.$store.commit("setLoader", true);

      let myURL = '/treino';
      if(this.periodoSelecionado.dias == 1){
        myURL += '/numerodetreinosprogramados';
      }else{
        myURL += '/meustreinosporperiodo';
      }

      axios({
        method: 'post',
        url : this.myHost + myURL, 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(this.periodoSelecionado)
      })
      .then(response => {
        this.treinoList = response.data;
        this.$store.commit("setLoader", false);
      })
      .catch(error => {
        this.dialogLoader = false;
        console.log(error.message);
        this.$store.commit("logout");
        this.$router.push("/");
      });
    },

  }
};
</script>